import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryShowcase from './components/CategoryShowcase';
import TrendingVideos from './components/TrendingVideos';
import RecommendedArticles from './components/RecommendedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const webPageLD = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '国产视频大全 - 首页',
    description: '国产视频精选平台，汇聚海量正版高清国产视频资源，涵盖影视剧、综艺、纪录片、短视频等多元内容。',
    url: 'https://www.guochanshipin.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '国产视频大全',
      url: 'https://www.guochanshipin.com/',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageLD)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryShowcase />
        <TrendingVideos />
        <RecommendedArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}